<template>
  <card class="card-user text-center">
    <div slot="image" class="image">
      <img src="/img/bg/college.jpg" alt="college-background">
    </div>
    <div>
      <div class="author">
          <div class="avatar border-gray">
            <img :src="avatar" alt="profile-picture">
          </div>
          <h5 class="title">{{ $currentUser.name }}</h5>
          <p class="description">{{ $currentUser.register_no }}</p>
          <small class="description">{{ $currentUser.mail }}</small>

          <p class="description">{{ $currentUser.course ? $currentUser.course : $currentUser.deanery }}</p>
          <p class="description">{{ $currentUser.department }}</p>
      </div>
    </div>
    <div slot="footer" class="button-container" v-if="false">
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fa fa-facebook-square"></i>
      </n-button>
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fa fa-twitter"></i>
      </n-button>
      <n-button href="#" type="neutral" icon round size="lg">
        <i class="fa fa-google-plus-square"></i>
      </n-button>
    </div>
  </card>
</template>
<script>
export default {
  computed: {
    avatar(){
      let isStudent = this.$currentUser.roles.some((role) => role === 'student')
      if(isStudent){
        return this.$currentUser.image;
      }
      else{
        return `https://ui-avatars.com/api/?background=fff&color=0D8ABC&bold=true&size=128&name=${this.$currentUser.name}`;
      }
      return this.$currentUser.image;
    }
  }
};
</script>
<style lang="scss">
  .card-user{
    .avatar{
      margin: 0 auto;
      box-shadow: 0px 2px 3px rgba(0,0,0,0.25);
      margin-bottom: 15px;
    }

    .image{
      filter: brightness(0.75);
    }

    .author{
      .title{
        margin-bottom: 5px;
      }

      small{
        font-weight: bold;
      }

      .description{
        margin-top: 5px;
        margin-bottom: 0px;
      }
    }

    .description{
      margin-top: 10px;
    }
  }
</style>
